import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedUiComponentsCoreModule } from '@domgen/dgx-fe-components-core';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { SharedUiDynamicFormBuilderModule } from '@domgen/dgx-fe-dynamic-form-builder';
import { SkyUiAddDeviceComponent } from './add-device/add-device.component';
import { SkyUiCategoryFormComponent } from './category-form/category-form.component';
import { DeviceDetailComponent } from './device-details/device-detail.component';
import { SkyUiDeviceFormComponent } from './device-form/device-form.component';
import { ExcessFormSectionComponent } from './excess-form-section/excess-form-section.component';
import { IMEISectionComponent } from './imei-section/imei-section.component';
import { InfoBannerComponent } from './info-banner/info-banner.component';
import { LostTheftFormComponent } from './lost-theft-form/lost-theft-form.component';
import { MobileInfoComponent } from './mobile-info/mobile-info.component';
@NgModule({
  imports: [
    CommonModule,
    SharedUiDynamicFormBuilderModule,
    SharedUiComponentsCoreModule,
    ReactiveFormsModule,
    RouterModule,
    DgxComponentsButtonModule,
  ],
  declarations: [
    SkyUiAddDeviceComponent,
    SkyUiCategoryFormComponent,
    LostTheftFormComponent,
    ExcessFormSectionComponent,
    IMEISectionComponent,
    SkyUiDeviceFormComponent,
    DeviceDetailComponent,
    MobileInfoComponent,
    InfoBannerComponent,
  ],
  exports: [
    SkyUiAddDeviceComponent,
    SkyUiCategoryFormComponent,
    LostTheftFormComponent,
    ExcessFormSectionComponent,
    IMEISectionComponent,
    SkyUiDeviceFormComponent,
    DeviceDetailComponent,
    MobileInfoComponent,
    InfoBannerComponent,
  ],
})
export class AddDeviceUiModule {}
